const drawerToggleReducer = (
  state = {
    drawerOpen: true,
  },
  action: { type: string; payload?: any }
) => {
  switch (action.type) {
    case "SET_DRAWER_TOGGLE_STATUS":
      return { ...state, drawerOpen: action.payload };
    default:
      return state;
  }
};

export default drawerToggleReducer;